import PermMedia from "@mui/icons-material/PermMedia";
import { useDialog } from "../../../../../utils/hooks/use-dialog";
import { AddImagesAndFilesModal } from "./add-images-and-files-modal";
import { ToolbarIconButton } from "./toolbar-icon-button";

import type { ToolbarProps } from "./props";
import type { IconButtonProps } from "@mui/material";
import type { FC } from "react";

interface AddImagesAndFilesButtonProps extends IconButtonProps {
  label?: string;
  onClose?: () => void;
}

export const AddImagesAndFilesButton: FC<ToolbarProps & AddImagesAndFilesButtonProps> = ({
  disabled,
  label,
  onClose,
}) => {
  const dialog = useDialog();

  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-toolbar-add-images-and-files"
        disabled={disabled}
        label={label}
        icon={<PermMedia fontSize="medium" />}
        data-testid="toolbar-button-add-images-and-files"
        aria-label="add-images-and-files"
        tabIndex={-1}
        onClick={dialog.handleOpen}
      />
      <AddImagesAndFilesModal
        open={dialog.open}
        onClose={() => {
          onClose?.();
          dialog.handleClose();
        }}
      />
    </>
  );
};
